import React, { useContext, useMemo } from 'react'

import {
    uploadFieldParser,
    uploadInputSelector,
} from '../../../../utils/form/formFieldParser'
import { DataContext } from '../DataContext'
import SectionWrapper from './SectionWrapper'

export default ({ config, title, subtitle }) => {
    const { viewOnly, submissionState, formMethods } = useContext(DataContext)
    const formWidth = 'full'
    const backgroundColorClass = ''
    
    const fields = useMemo(() => {
        return uploadFieldParser(
            config,
            formWidth,
            null,
            backgroundColorClass,
            uploadInputSelector,
            viewOnly
        )
    }, [config, viewOnly, submissionState, formMethods])

    return (
        <SectionWrapper title={title} subtitle={subtitle}>
            <div className="formWrapper">{fields}</div>
        </SectionWrapper>
    )
}
